(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clearance2-flash"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseBeijingTime(value) {
      var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
      if (!match) {
        return NaN;
      }

      var endTime = Date.parse(match.slice(1).join('').replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3T$4:$5:$6+08:00'));
      if (Number.isNaN(endTime)) {
        return NaN;
      }

      var beijingDate = new Date(endTime + 8 * 60 * 60 * 1000);
      var values = [
        beijingDate.getUTCFullYear(),
        beijingDate.getUTCMonth() + 1,
        beijingDate.getUTCDate(),
        beijingDate.getUTCHours(),
        beijingDate.getUTCMinutes(),
        beijingDate.getUTCSeconds()
      ];

      for (var index = 0; index < values.length; index += 1) {
        if (values[index] !== Number(match[index + 1])) {
          return NaN;
        }
      }

      return endTime;
    }

    function setText(section, selector, value) {
      var element = section.querySelector(selector);
      if (element) {
        element.textContent = String(value).padStart(2, '0');
      }
    }

    function endSale(section) {
      var hideOnExpiry = section.getAttribute('data-hide-on-expiry') === 'true';
      var timer = section.querySelector('[data-flash-timer]');
      var activeLabel = section.querySelector('[data-flash-active-label]');
      var ended = section.querySelector('[data-flash-ended]');
      var endedText = section.getAttribute('data-ended-text') || 'Sale ended';

      section.setAttribute('data-sale-ended', 'true');
      if (hideOnExpiry) {
        section.hidden = true;
        return;
      }
      if (timer) {
        timer.hidden = true;
      }
      if (activeLabel) {
        activeLabel.hidden = true;
      }
      if (ended) {
        ended.hidden = false;
      }

      section.querySelectorAll('[data-flash-submit]').forEach(function(button) {
        button.disabled = true;
        button.textContent = endedText;
      });
    }

    function updateCountdown(section, endTime) {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        endSale(section);
        if (section.munbynFlashTimer) {
          window.clearInterval(section.munbynFlashTimer);
          section.munbynFlashTimer = null;
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setText(section, '[data-flash-days]', days);
      setText(section, '[data-flash-hours]', hours);
      setText(section, '[data-flash-minutes]', minutes);
      setText(section, '[data-flash-seconds]', seconds);
    }

    function initFlashSale(section) {
      if (section.munbynFlashTimer) {
        window.clearInterval(section.munbynFlashTimer);
      }

      if (Number(section.getAttribute('data-product-count')) <= 0) {
        section.hidden = true;
        return;
      }

      var endDate = section.getAttribute('data-end-date');
      var endTime = parseBeijingTime(endDate);
      if (!endDate || Number.isNaN(endTime)) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      section.removeAttribute('data-sale-ended');
      updateCountdown(section, endTime);
      if (!section.hasAttribute('data-sale-ended')) {
        section.munbynFlashTimer = window.setInterval(function() {
          updateCountdown(section, endTime);
        }, 1000);
      }
    }

    function copyCode(button) {
      var code = button.getAttribute('data-flash-copy-code');
      var label = button.querySelector('[data-flash-copy-label]');
      var copyLabel = button.getAttribute('data-copy-label') || 'Copy';
      var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
      if (!code || !label) {
        return;
      }

      var showCopied = function() {
        label.textContent = copiedLabel;
        window.setTimeout(function() {
          label.textContent = copyLabel;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function() {
          label.textContent = code;
        });
        return;
      }

      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        showCopied();
      } catch (error) {
        label.textContent = code;
      }
      document.body.removeChild(input);
    }

    function initAllFlashSales(root) {
      if (root.matches && root.matches('[data-munbyn-cs2-flash-sale]')) {
        initFlashSale(root);
      }
      root.querySelectorAll('[data-munbyn-cs2-flash-sale]').forEach(initFlashSale);
    }

    if (!window.munbynFlashSaleEventsBound) {
      document.addEventListener('click', function(event) {
        var button = event.target.closest('[data-flash-copy-code]');
        if (button) {
          copyCode(button);
        }
      });

      document.addEventListener('shopify:section:load', function(event) {
        initAllFlashSales(event.target);
      });

      window.munbynFlashSaleEventsBound = true;
    }

    initAllFlashSales(document);
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlashSales(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clearance2-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-show-more-toggle]');
    if (!toggle) {
      return;
    }

    var section = toggle.closest('.munbyn-cs2-splash-products');
    if (!section) {
      return;
    }

    var cards = section.querySelectorAll('.munbyn-cs2-splash-deal-card--extra');
    var label = toggle.querySelector('[data-show-more-text]');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    cards.forEach(function(card) {
      card.hidden = isExpanded;
    });

    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    if (label) {
      label.textContent = isExpanded ? 'Show more >' : 'Show less >';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-benefits"] && !Shopify.designMode) return;
  try {
    
  function updateReviewControls(section) {
    var carousel = section.querySelector('[data-review-carousel]');
    var previous = section.querySelector('[data-review-carousel-previous]');
    var next = section.querySelector('[data-review-carousel-next]');
    if (!carousel || !previous || !next) {
      return;
    }

    var maximumScroll = carousel.scrollWidth - carousel.clientWidth;
    previous.disabled = carousel.scrollLeft <= 1;
    next.disabled = carousel.scrollLeft >= maximumScroll - 1;
  }

  function initialiseReviewCarousel(section) {
    var carousel = section.querySelector('[data-review-carousel]');
    if (!carousel || carousel.dataset.controlsInitialised === 'true') {
      return;
    }

    carousel.dataset.controlsInitialised = 'true';
    carousel.addEventListener('scroll', function() {
      updateReviewControls(section);
    }, { passive: true });
    updateReviewControls(section);
  }

  document.querySelectorAll('.munbyn-deal-benefits').forEach(initialiseReviewCarousel);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.munbyn-deal-benefits');
    if (section) {
      initialiseReviewCarousel(section);
    }
  });

  document.addEventListener('click', function(event) {
    var control = event.target.closest('[data-review-carousel-previous], [data-review-carousel-next]');
    if (!control) {
      return;
    }

    var section = control.closest('.munbyn-deal-benefits');
    var carousel = section ? section.querySelector('[data-review-carousel]') : null;
    var card = carousel ? carousel.querySelector('.munbyn-splash-review') : null;
    if (!carousel || !card) {
      return;
    }

    var gap = parseFloat(window.getComputedStyle(carousel).columnGap) || 0;
    var direction = control.hasAttribute('data-review-carousel-previous') ? -1 : 1;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    carousel.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-business-links"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initialiseBusinessLinksCarousel(root) {
      var carousel = root.matches && root.matches('[data-business-links-carousel]')
        ? root
        : root.querySelector('[data-business-links-carousel]');

      if (!carousel || carousel.dataset.carouselInitialised === 'true') {
        return;
      }

      var viewport = carousel.querySelector('[data-business-links-viewport]');
      var slides = carousel.querySelectorAll('.deal-business-links__slide');
      var previous = carousel.querySelector('[data-business-links-previous]');
      var next = carousel.querySelector('[data-business-links-next]');
      var dots = carousel.querySelectorAll('[data-business-links-dot]');

      if (!viewport || slides.length < 2 || !previous || !next) {
        return;
      }

      carousel.dataset.carouselInitialised = 'true';
      var activeIndex = 0;
      var scrollFrame;

      function updateControls(index) {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;

        dots.forEach(function(dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('deal-business-links__dot--active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function goTo(index) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        viewport.scrollTo({
          left: viewport.clientWidth * index,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
        updateControls(index);
      }

      previous.addEventListener('click', function() {
        goTo(activeIndex - 1);
      });

      next.addEventListener('click', function() {
        goTo(activeIndex + 1);
      });

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          goTo(index);
        });
      });

      viewport.addEventListener('scroll', function() {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function() {
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          updateControls(index);
        });
      }, { passive: true });

      window.addEventListener('resize', function() {
        goTo(activeIndex);
      });

      updateControls(0);
    }

    function initialiseAllBusinessLinksCarousels(root) {
      if (root.matches && root.matches('[data-business-links-carousel]')) {
        initialiseBusinessLinksCarousel(root);
      }
      root.querySelectorAll('[data-business-links-carousel]').forEach(initialiseBusinessLinksCarousel);
    }

    initialiseAllBusinessLinksCarousels(document);

    if (!window.munbynBusinessLinksCarouselEventsBound) {
      document.addEventListener('shopify:section:load', function(event) {
        initialiseAllBusinessLinksCarousels(event.target);
      });
      window.munbynBusinessLinksCarouselEventsBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-flash-sale"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseBeijingTime(value) {
      var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
      if (!match) {
        return NaN;
      }

      var endTime = Date.parse(match.slice(1).join('').replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3T$4:$5:$6+08:00'));
      if (Number.isNaN(endTime)) {
        return NaN;
      }

      var beijingDate = new Date(endTime + 8 * 60 * 60 * 1000);
      var values = [
        beijingDate.getUTCFullYear(),
        beijingDate.getUTCMonth() + 1,
        beijingDate.getUTCDate(),
        beijingDate.getUTCHours(),
        beijingDate.getUTCMinutes(),
        beijingDate.getUTCSeconds()
      ];

      for (var index = 0; index < values.length; index += 1) {
        if (values[index] !== Number(match[index + 1])) {
          return NaN;
        }
      }

      return endTime;
    }

    function setText(section, selector, value) {
      var element = section.querySelector(selector);
      if (element) {
        element.textContent = String(value).padStart(2, '0');
      }
    }

    function endSale(section) {
      var hideOnExpiry = section.getAttribute('data-hide-on-expiry') === 'true';
      var timer = section.querySelector('[data-flash-timer]');
      var activeLabel = section.querySelector('[data-flash-active-label]');
      var ended = section.querySelector('[data-flash-ended]');
      var endedText = section.getAttribute('data-ended-text') || 'Sale ended';

      section.setAttribute('data-sale-ended', 'true');
      if (hideOnExpiry) {
        section.hidden = true;
        return;
      }
      if (timer) {
        timer.hidden = true;
      }
      if (activeLabel) {
        activeLabel.hidden = true;
      }
      if (ended) {
        ended.hidden = false;
      }

      section.querySelectorAll('[data-flash-submit]').forEach(function(button) {
        button.disabled = true;
        button.textContent = endedText;
      });
    }

    function updateCountdown(section, endTime) {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        endSale(section);
        if (section.munbynFlashTimer) {
          window.clearInterval(section.munbynFlashTimer);
          section.munbynFlashTimer = null;
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setText(section, '[data-flash-days]', days);
      setText(section, '[data-flash-hours]', hours);
      setText(section, '[data-flash-minutes]', minutes);
      setText(section, '[data-flash-seconds]', seconds);
    }

    function initFlashSale(section) {
      if (section.munbynFlashTimer) {
        window.clearInterval(section.munbynFlashTimer);
      }

      if (Number(section.getAttribute('data-product-count')) <= 0) {
        section.hidden = true;
        return;
      }

      var endDate = section.getAttribute('data-end-date');
      var endTime = parseBeijingTime(endDate);
      if (!endDate || Number.isNaN(endTime)) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      section.removeAttribute('data-sale-ended');
      updateCountdown(section, endTime);
      if (!section.hasAttribute('data-sale-ended')) {
        section.munbynFlashTimer = window.setInterval(function() {
          updateCountdown(section, endTime);
        }, 1000);
      }
    }

    function copyCode(button) {
      var code = button.getAttribute('data-flash-copy-code');
      var label = button.querySelector('[data-flash-copy-label]');
      var copyLabel = button.getAttribute('data-copy-label') || 'Copy';
      var copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
      if (!code || !label) {
        return;
      }

      var showCopied = function() {
        label.textContent = copiedLabel;
        window.setTimeout(function() {
          label.textContent = copyLabel;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function() {
          label.textContent = code;
        });
        return;
      }

      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        showCopied();
      } catch (error) {
        label.textContent = code;
      }
      document.body.removeChild(input);
    }

    function initAllFlashSales(root) {
      if (root.matches && root.matches('[data-munbyn-flash-sale]')) {
        initFlashSale(root);
      }
      root.querySelectorAll('[data-munbyn-flash-sale]').forEach(initFlashSale);
    }

    if (!window.munbynFlashSaleEventsBound) {
      document.addEventListener('click', function(event) {
        var button = event.target.closest('[data-flash-copy-code]');
        if (button) {
          copyCode(button);
        }
      });

      document.addEventListener('shopify:section:load', function(event) {
        initAllFlashSales(event.target);
      });

      window.munbynFlashSaleEventsBound = true;
    }

    initAllFlashSales(document);
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlashSales(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-hero"] && !Shopify.designMode) return;
  try {
    
  function parseMunbynBeijingTime(value) {
    var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
    if (!match) {
      return NaN;
    }

    var isoValue = match[1] + '-' + match[2] + '-' + match[3] + 'T' + match[4] + ':' + match[5] + ':' + match[6] + '+08:00';
    var endTime = Date.parse(isoValue);
    if (Number.isNaN(endTime)) {
      return NaN;
    }

    var beijingDate = new Date(endTime + 8 * 60 * 60 * 1000);
    var values = [
      beijingDate.getUTCFullYear(),
      beijingDate.getUTCMonth() + 1,
      beijingDate.getUTCDate(),
      beijingDate.getUTCHours(),
      beijingDate.getUTCMinutes(),
      beijingDate.getUTCSeconds()
    ];

    for (var index = 0; index < values.length; index += 1) {
      if (values[index] !== Number(match[index + 1])) {
        return NaN;
      }
    }

    return endTime;
  }

  function initMunbynHeroCountdowns() {
    var timers = document.querySelectorAll('[data-hero-countdown]');
    timers.forEach(function(timer) {
      if (timer.dataset.countdownReady === 'true') {
        return;
      }

      var endValue = timer.getAttribute('data-countdown-end');
      var endTime = parseMunbynBeijingTime(endValue);
      if (!endValue || Number.isNaN(endTime)) {
        timer.hidden = true;
        return;
      }

      timer.dataset.countdownReady = 'true';
      var daysEl = timer.querySelector('[data-countdown-days]');
      var hoursEl = timer.querySelector('[data-countdown-hours]');
      var minutesEl = timer.querySelector('[data-countdown-minutes]');
      var secondsEl = timer.querySelector('[data-countdown-seconds]');
      var expiredEl = timer.querySelector('[data-countdown-expired]');
      var expiredText = timer.getAttribute('data-countdown-expired-text') || '';

      var pad = function(value) {
        return String(value).padStart(2, '0');
      };

      var interval;
      var render = function() {
        var distance = endTime - Date.now();
        if (distance <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          if (expiredEl && expiredText) {
            expiredEl.textContent = expiredText;
            expiredEl.hidden = false;
          }
          window.clearInterval(interval);
          return;
        }

        var totalSeconds = Math.floor(distance / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      };

      render();
      interval = window.setInterval(render, 1000);
    });
  }

  initMunbynHeroCountdowns();
  document.addEventListener('shopify:section:load', initMunbynHeroCountdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-kit-comparison"] && !Shopify.designMode) return;
  try {
    
  function refreshKitPreview(card) {
    var includesWrap = card.querySelector('[data-kit-includes-wrap]');
    var includes = card.querySelector('[data-kit-includes]');
    var fullButton = card.querySelector('[data-kit-view-full]');
    if (!includesWrap || !includes || !fullButton) {
      return;
    }

    window.requestAnimationFrame(function() {
      var isOverflowing = !includesWrap.hidden && includes.scrollHeight > includes.clientHeight + 1;
      fullButton.hidden = !isOverflowing;
    });
  }

  function refreshKitPreviews(root) {
    root.querySelectorAll('[data-kit-card]').forEach(refreshKitPreview);
  }

  function getKitVisibleLimit(section) {
    var desktopLimit = parseInt(section.getAttribute('data-kit-desktop-visible'), 10) || 3;
    var tabletLimit = parseInt(section.getAttribute('data-kit-tablet-visible'), 10) || 2;
    var mobileLimit = parseInt(section.getAttribute('data-kit-mobile-visible'), 10) || 4;

    if (window.matchMedia('(max-width: 620px)').matches) {
      return mobileLimit;
    }

    if (window.matchMedia('(max-width: 989px)').matches) {
      return tabletLimit;
    }

    return desktopLimit;
  }

  function refreshKitVisibility(section) {
    var cards = section.querySelectorAll('[data-kit-card]');
    var showMoreButton = section.querySelector('[data-kit-show-more]');
    var toggleWrap = section.querySelector('[data-kit-toggle-wrap]');
    var visibleLimit = getKitVisibleLimit(section);
    var isExpanded = showMoreButton && showMoreButton.getAttribute('aria-expanded') === 'true';

    cards.forEach(function(card, index) {
      card.hidden = !isExpanded && index >= visibleLimit;
    });

    if (toggleWrap) {
      toggleWrap.hidden = cards.length <= visibleLimit;
    }
  }

  function refreshKitVisibilities(root) {
    if (root.matches && root.matches('.munbyn-kit-comparison')) {
      refreshKitVisibility(root);
    }

    root.querySelectorAll('.munbyn-kit-comparison').forEach(refreshKitVisibility);
  }

  refreshKitVisibilities(document);
  refreshKitPreviews(document);

  document.addEventListener('shopify:section:load', function(event) {
    refreshKitVisibilities(event.target);
    refreshKitPreviews(event.target);
  });

  window.addEventListener('resize', function() {
    refreshKitVisibilities(document);
    refreshKitPreviews(document);
  });

  document.addEventListener('change', function(event) {
    var selector = event.target.closest('[data-kit-variant-selector]');
    if (!selector) {
      return;
    }

    var card = selector.closest('[data-kit-card]');
    var option = selector.options[selector.selectedIndex];
    if (!card || !option) {
      return;
    }

    var variantInput = card.querySelector('[data-kit-variant-input]');
    var addButton = card.querySelector('[data-kit-add-button]');
    var price = card.querySelector('[data-kit-price]');
    var installmentPrice = card.querySelector('[data-kit-installment-price]');
    var compareAt = card.querySelector('[data-kit-compare-at]');
    var image = card.querySelector('.munbyn-kit-card__image');
    var productLinks = card.querySelectorAll('[data-kit-product-link]');
    var includesWrap = card.querySelector('[data-kit-includes-wrap]');
    var includes = card.querySelector('[data-kit-includes]');
    var template = document.getElementById(option.getAttribute('data-kit-template'));
    var isAvailable = option.getAttribute('data-available') === 'true';
    var productUrl = option.getAttribute('data-product-url') || '';

    if (variantInput) {
      variantInput.value = option.value;
    }

    if (addButton) {
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? card.getAttribute('data-add-label') || 'Add Kit' : 'Sold Out';
    }

    if (price) {
      price.textContent = option.getAttribute('data-price') || '';
    }

    if (installmentPrice) {
      installmentPrice.textContent = option.getAttribute('data-installment-price') || '';
    }

    if (compareAt) {
      var compareAtText = option.getAttribute('data-compare-at') || '';
      compareAt.textContent = compareAtText;
      compareAt.hidden = !compareAtText;
    }

    if (image) {
      var imageUrl = option.getAttribute('data-image') || '';
      if (imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
      }
    }

    productLinks.forEach(function(link) {
      if (productUrl) {
        link.href = productUrl;
      }
    });

    if (includes && includesWrap) {
      var hasContent = template && template.getAttribute('data-kit-has-content') === 'true';
      includes.innerHTML = hasContent ? template.innerHTML : '';
      includesWrap.hidden = !hasContent;
      refreshKitPreview(card);
    }
  });

  document.addEventListener('click', function(event) {
    var fullButton = event.target.closest('[data-kit-view-full]');
    var closeButton = event.target.closest('[data-kit-dialog-close]');
    var showMoreButton = event.target.closest('[data-kit-show-more]');

    if (showMoreButton) {
      var showMoreSection = showMoreButton.closest('.munbyn-kit-comparison');
      var showMoreLabel = showMoreButton.querySelector('[data-kit-show-more-text]');
      var isExpanded = showMoreButton.getAttribute('aria-expanded') === 'true';

      showMoreButton.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (showMoreLabel) {
        showMoreLabel.textContent = isExpanded ? 'Show more' : 'Show less';
      }

      if (showMoreSection) {
        refreshKitVisibility(showMoreSection);
        refreshKitPreviews(showMoreSection);
      }
      return;
    }

    if (fullButton) {
      var card = fullButton.closest('[data-kit-card]');
      var section = fullButton.closest('.munbyn-kit-comparison');
      var dialog = section ? section.querySelector('[data-kit-dialog]') : null;
      var dialogContent = dialog ? dialog.querySelector('[data-kit-dialog-content]') : null;
      var dialogContext = dialog ? dialog.querySelector('[data-kit-dialog-context]') : null;
      var includes = card ? card.querySelector('[data-kit-includes]') : null;
      var selector = card ? card.querySelector('[data-kit-variant-selector]') : null;
      if (!card || !dialog || !dialogContent || !includes) {
        return;
      }

      var context = card.getAttribute('data-kit-card-title') || '';
      if (selector && selector.options[selector.selectedIndex]) {
        context = context + ' - ' + selector.options[selector.selectedIndex].textContent.replace(' - Sold out', '').trim();
      }

      dialogContent.innerHTML = includes.innerHTML;
      if (dialogContext) {
        dialogContext.textContent = context;
      }
      dialog.showModal();
      return;
    }

    if (closeButton) {
      var closeDialog = closeButton.closest('[data-kit-dialog]');
      if (closeDialog) {
        closeDialog.close();
      }
      return;
    }

    var openDialog = event.target.matches('[data-kit-dialog]') ? event.target : null;
    if (openDialog) {
      openDialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-style-controls"] && !Shopify.designMode) return;
  try {
    
  function applyMunbynDealFloatingTools() {
    var launcher = document.querySelector('shulex-chatbot-lancher');
    if (!launcher || !launcher.shadowRoot) {
      return false;
    }

    var style = launcher.shadowRoot.querySelector('[data-munbyn-deal-mobile-tools]');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute('data-munbyn-deal-mobile-tools', '');
      style.textContent = '@media screen and (max-width: 749px) { #livechat_launcher_btn { right: 12px !important; bottom: 16px !important; width: 42px !important; height: 42px !important; } #livechat_launcher_btn > div { width: 42px !important; height: 42px !important; border-radius: 21px !important; } }';
      launcher.shadowRoot.appendChild(style);
    }

    return true;
  }

  function initialiseMunbynDealFloatingTools() {
    if (applyMunbynDealFloatingTools()) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;
      if (applyMunbynDealFloatingTools() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  initialiseMunbynDealFloatingTools();
  document.addEventListener('shopify:section:load', initialiseMunbynDealFloatingTools);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-label-quantity-deals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var option = event.target.closest('[data-label-option]');
    var toggle = event.target.closest('[data-label-deals-toggle]');

    if (option) {
      var card = option.closest('.munbyn-label-quantity-card');
      if (!card) {
        return;
      }

      var options = card.querySelectorAll('[data-label-option]');
      var variantInput = card.querySelector('[data-label-variant-input]');
      var buyButton = card.querySelector('[data-label-buy-button]');
      var learnLinks = card.querySelectorAll('[data-label-learn-link]');
      var ribbon = card.querySelector('[data-label-ribbon-percent]');
      var savings = card.querySelector('[data-label-savings]');
      var image = card.querySelector('.munbyn-label-quantity-card__image');

      options.forEach(function(item) {
        var isActive = item === option;
        item.classList.toggle('munbyn-label-quantity-card__option--active', isActive);
        item.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (variantInput) {
        variantInput.value = option.getAttribute('data-variant-id') || '';
      }

      if (buyButton) {
        var isAvailable = option.getAttribute('data-available') === 'true';
        buyButton.disabled = !isAvailable;
        buyButton.textContent = isAvailable ? card.getAttribute('data-buy-label') || 'Add To Cart' : 'Sold Out';
      }

      learnLinks.forEach(function(link) {
        link.href = option.getAttribute('data-product-url') || link.href;
      });

      if (ribbon) {
        var discount = option.getAttribute('data-discount') || '';
        if (discount) {
          ribbon.textContent = discount;
        }
      }

      if (savings) {
        var saveText = option.getAttribute('data-save') || '';
        savings.textContent = saveText;
        savings.hidden = !saveText;
      }

      if (image) {
        var imageUrl = option.getAttribute('data-image') || '';
        if (imageUrl) {
          image.src = imageUrl;
          image.removeAttribute('srcset');
        }
      }
    }

    if (toggle) {
      var section = toggle.closest('.munbyn-label-quantity-deals');
      var extras = section ? section.querySelectorAll('.munbyn-label-quantity-card--extra') : [];
      var label = toggle.querySelector('[data-label-deals-toggle-text]');
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      extras.forEach(function(card) {
        card.hidden = isExpanded;
      });

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (label) {
        label.textContent = isExpanded ? 'Show more >' : 'Show less >';
      }
    }
  });

  function refreshLabelQuantityDeals() {
    document.querySelectorAll('[data-label-deals-section]').forEach(function(section) {
      var desktopCount = parseInt(section.getAttribute('data-desktop-visible-count'), 10) || 6;
      var mobileCount = parseInt(section.getAttribute('data-mobile-visible-count'), 10) || 4;
      var visibleCount = window.matchMedia('(max-width: 680px)').matches ? mobileCount : desktopCount;
      var cards = section.querySelectorAll('[data-label-card]');
      var toggleWrap = section.querySelector('[data-label-deals-toggle-wrap]');
      var toggle = section.querySelector('[data-label-deals-toggle]');
      var label = section.querySelector('[data-label-deals-toggle-text]');
      var isExpanded = toggle ? toggle.getAttribute('aria-expanded') === 'true' : false;
      var hasExtras = cards.length > visibleCount;

      cards.forEach(function(card, index) {
        var isExtra = index + 1 > visibleCount;
        card.classList.toggle('munbyn-label-quantity-card--extra', isExtra);
        card.hidden = isExtra && !isExpanded;
      });

      if (toggleWrap) {
        toggleWrap.hidden = !hasExtras;
      }

      if (toggle && !hasExtras) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (label) {
        label.textContent = isExpanded && hasExtras ? 'Show less >' : 'Show more >';
      }
    });
  }

  refreshLabelQuantityDeals();
  document.addEventListener('DOMContentLoaded', refreshLabelQuantityDeals);
  window.addEventListener('resize', refreshLabelQuantityDeals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-categories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function copyCategoryCode(button) {
      var code = button.getAttribute('data-category-copy-code');
      var label = button.querySelector('.munbyn-splash-category-product__copy-label');
      if (!code || !label) {
        return;
      }

      var originalText = label.textContent;
      var markCopied = function() {
        label.textContent = 'Copied';
        window.setTimeout(function() {
          label.textContent = originalText;
        }, 1400);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(markCopied).catch(function() {
          label.textContent = code;
        });
        return;
      }

      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        markCopied();
      } catch (error) {
        label.textContent = code;
      }
      document.body.removeChild(input);
    }

    function getVisibleLimit(section) {
      return Number(section.getAttribute('data-visible-count')) || 4;
    }

    function updateSection(section, target, isExpanded) {
      var tabs = section.querySelectorAll('[data-category-tab]');
      var cards = section.querySelectorAll('[data-category-card]');
      var button = section.querySelector('[data-category-show-more]');
      var label = section.querySelector('[data-category-show-more-text]');
      var wrap = section.querySelector('[data-category-toggle-wrap]');
      var visibleLimit = getVisibleLimit(section);
      var visibleCount = 0;
      var extraCount = 0;

      tabs.forEach(function(item) {
        var isActive = item.getAttribute('data-category-tab') === target;
        item.classList.toggle('munbyn-splash-categories__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      cards.forEach(function(card) {
        var isTarget = card.getAttribute('data-category-card') === target;
        var index = Number(card.getAttribute('data-category-index')) || 0;
        if (isTarget) {
          visibleCount += 1;
        }
        if (isTarget && index > visibleLimit) {
          extraCount += 1;
        }
        card.hidden = !isTarget || (!isExpanded && index > visibleLimit);
      });

      if (button) {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }

      if (label) {
        label.textContent = isExpanded ? 'Show less >' : 'Show more >';
      }

      if (wrap) {
        wrap.hidden = visibleCount <= visibleLimit || extraCount === 0;
      }

      var grid = section.querySelector('.munbyn-splash-categories__grid');
      if (grid) {
        grid.setAttribute('data-visible-total', String(Math.min(visibleCount, isExpanded ? visibleCount : visibleLimit)));
      }
    }

    function getActiveCategory(section) {
      var activeTab = section.querySelector('.munbyn-splash-categories__tab--active');
      var firstTab = section.querySelector('[data-category-tab]');
      return activeTab ? activeTab.getAttribute('data-category-tab') : firstTab ? firstTab.getAttribute('data-category-tab') : '';
    }

    function updateAllSections() {
      document.querySelectorAll('.munbyn-splash-categories').forEach(function(section) {
        var button = section.querySelector('[data-category-show-more]');
        var isExpanded = button ? button.getAttribute('aria-expanded') === 'true' : false;
        updateSection(section, getActiveCategory(section), isExpanded);
      });
    }

    var resizeTimer;
    document.addEventListener('click', function(event) {
      var copyButton = event.target.closest('[data-category-copy-code]');
      if (copyButton) {
        copyCategoryCode(copyButton);
        return;
      }

      var tab = event.target.closest('[data-category-tab]');
      var toggle = event.target.closest('[data-category-show-more]');
      if (!tab && !toggle) {
        return;
      }

      var section = (tab || toggle).closest('.munbyn-splash-categories');
      if (!section) {
        return;
      }

      var button = section.querySelector('[data-category-show-more]');
      var target = tab ? tab.getAttribute('data-category-tab') : getActiveCategory(section);
      var isExpanded = toggle && button ? button.getAttribute('aria-expanded') !== 'true' : false;

      updateSection(section, target, isExpanded);
    });

    updateAllSections();
    document.addEventListener('DOMContentLoaded', updateAllSections);
    document.addEventListener('shopify:section:load', updateAllSections);
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateAllSections, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var tab = event.target.closest('[data-feature-tab]');
    if (tab) {
      var feature = tab.closest('.munbyn-splash-feature');
      if (!feature) {
        return;
      }

      var target = tab.getAttribute('data-feature-tab');
      var tabs = feature.querySelectorAll('[data-feature-tab]');
      var panels = feature.querySelectorAll('[data-feature-panel]');

      tabs.forEach(function(item) {
        var isActive = item === tab;
        item.classList.toggle('munbyn-splash-feature__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function(panel) {
        var isTarget = panel.getAttribute('data-feature-panel') === target;
        panel.hidden = !isTarget;
        panel.classList.toggle('munbyn-splash-feature__card--hidden', !isTarget);
      });
      return;
    }

    var trigger = event.target.closest('[data-copy-code]');
    if (!trigger) {
      return;
    }

    var code = trigger.getAttribute('data-copy-code');
    var label = trigger.querySelector('.munbyn-splash-feature__copy-label');
    if (!code || !label) {
      return;
    }

    var originalText = label.textContent;
    var markCopied = function() {
      label.textContent = 'Copied';
      trigger.classList.add('is-copied');
      window.setTimeout(function() {
        label.textContent = originalText;
        trigger.classList.remove('is-copied');
      }, 1600);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(function() {
        label.textContent = code;
      });
      return;
    }

    var input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      markCopied();
    } catch (error) {
      label.textContent = code;
    }
    document.body.removeChild(input);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-show-more-toggle]');
    if (!toggle) {
      return;
    }

    var section = toggle.closest('.munbyn-splash-products');
    if (!section) {
      return;
    }

    var cards = section.querySelectorAll('.munbyn-splash-deal-card--extra');
    var label = toggle.querySelector('[data-show-more-text]');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    cards.forEach(function(card) {
      card.hidden = isExpanded;
    });

    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    if (label) {
      label.textContent = isExpanded ? 'Show more >' : 'Show less >';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["munbyn-splash-stock-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-stock-grid-toggle]');
    var copyButton = event.target.closest('[data-stock-code-copy]');

    if (toggle) {
      var section = toggle.closest('.munbyn-splash-stock-grid');
      var extras = section ? section.querySelectorAll('.munbyn-splash-stock-card--extra') : [];
      var label = toggle.querySelector('[data-stock-grid-toggle-text]');
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      extras.forEach(function(card) {
        card.hidden = isExpanded;
      });

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      if (label) {
        label.textContent = isExpanded ? 'Show more >' : 'Show less >';
      }
    }

    if (copyButton) {
      var code = copyButton.getAttribute('data-stock-code-copy');
      if (!code) {
        return;
      }

      var originalText = copyButton.textContent;
      var setCopied = function() {
        copyButton.textContent = 'Copied';
        window.setTimeout(function() {
          copyButton.textContent = originalText;
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(setCopied);
      } else {
        var field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        document.body.removeChild(field);
        setCopied();
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
